/**
 * Helpers for Store PO-intent / accept state when planning amends materials later.
 */

function toTime(value) {
  if (!value) return 0;
  const t = new Date(value).getTime();
  return Number.isFinite(t) ? t : 0;
}

/**
 * Planning re-submitted procurement requirements, or tools were amended, after Store
 * already accepted or set an availability/rejection decision.
 */
export function isStoreReviewStaleAfterAmendment(wo) {
  if (!wo?.needsStoreAction) return false;
  const storeDecisionAt = Math.max(toTime(wo.storeAcceptedAt), toTime(wo.storeRejectedAt));
  if (!storeDecisionAt) return false;

  const providedAt = toTime(wo.partsProcurementRequirements?.providedAt);
  const toolsUpdatedAt = toTime(wo.requiredToolsUpdatedAt);
  const materialUpdatedAt = Math.max(providedAt, toolsUpdatedAt);
  if (!materialUpdatedAt) return false;

  return materialUpdatedAt > storeDecisionAt;
}

/** Store step is done for queue/dashboard purposes (amendments reopen it). */
export function isStoreIntentCompleted(wo) {
  if (wo?.status === 'COMPLETED') return true;
  if (isStoreReviewStaleAfterAmendment(wo)) return false;
  return Boolean(wo?.storeAccepted);
}

/** Store still owes an accept/reject action. */
export function needsStoreIntentAction(wo) {
  if (!wo?.needsStoreAction) return false;
  if (wo?.status === 'CANCELLED' || wo?.status === 'COMPLETED') return false;
  if (isStoreReviewStaleAfterAmendment(wo)) return true;
  return !wo.storeAccepted && !wo.storeRejectedAt;
}

export function getStoreIntentLastUpdatedTime(wo) {
  const providedAt = toTime(wo?.partsProcurementRequirements?.providedAt);
  const toolsUpdatedAt = toTime(wo?.requiredToolsUpdatedAt);
  const storeAcceptedAt = toTime(wo?.storeAcceptedAt);
  const completedAt = toTime(wo?.completedAt);
  const updatedAt = toTime(wo?.updatedAt);
  const scheduledDate = toTime(wo?.scheduledDate);
  const createdAt = toTime(wo?.createdAt);
  return Math.max(
    providedAt,
    toolsUpdatedAt,
    storeAcceptedAt,
    completedAt,
    updatedAt,
    scheduledDate,
    createdAt
  );
}
